import React from 'react';
import { XIcon } from 'lucide-react';
import { Heading, Kicker, Lead, Section } from './ui';
import { painPoints } from '../../data/vcars';
export function ProblemSection() {
  return <Section className="bg-[#08090b]" data-id="element-61" data-mp="v6led1nk01uj">
      <Kicker data-id="element-62" data-mp="v5jtk5gqk0zm">El problema</Kicker>
      <Heading className="mt-4 max-w-2xl text-white" data-id="element-63" data-mp="v8o3ljgvtqy7">
        Comprar o cambiar un auto no debería ser complicado
      </Heading>
      <Lead className="mt-4 max-w-xl text-white/55" data-id="element-64" data-mp="3f5ieh03x2rn">
        Pero muchas veces el proceso se vuelve confuso, lento y lleno de dudas.
      </Lead>

      <ul className="mt-10 grid gap-x-10 sm:grid-cols-2" data-id="element-65" data-mp="3unt5b1dzwy1b">
        {painPoints.map(point => <li key={point} className="flex items-start gap-3 border-t border-white/10 py-4" data-id="element-66" data-mp="chwumj0t42kc">
            <XIcon className="mt-0.5 h-5 w-5 shrink-0 text-[#ff5a5a]" strokeWidth={3} data-id="element-67" data-mp="7jll69efbu2n" />
            <span className="text-base text-white/80 sm:text-lg" data-id="element-68" data-mp="1iwxl4972bsjj">{point}</span>
          </li>)}
      </ul>

      <p className="mt-10 max-w-2xl border-l-2 border-[#3b6bff] pl-5 text-lg leading-relaxed text-white sm:text-xl" data-id="element-69" data-mp="2majtjnf4xww6">
        Por eso en VCARS te acompañamos para que puedas tomar una decisión más
        segura, clara y conveniente.
      </p>
    </Section>;
}